<template lang="html">
  <section
    class="landing"
  >
    <div class="fullscreen-bg">
      <video
        class="fullscreen-bg_video" poster="/assets/video/videoplayback.00_00_22_00.Still001.png"
        autoplay="autoplay" loop="loop" muted="" crossorigin="anonymous"
      >
        <source src="/assets/video/videoplayback_4.webm" type="video/webm">
        <source src="/assets/video/videoplayback_4.ogv" type="video/ogg">
        <source src="/assets/video/videoplayback_4.mp4" type="video/mp4">
      </video>
    </div>
    <div
      :id="'navbar'"
      class="landing__nav-container"
      @scroll="hideNavOnScroll()"
    >
      <a
        href="#"
        @click.prevent="toggleMenu()"
        :class="[
          'toggle-menu__mobile',
          { 'opened' : isMenuOpened }
        ]"
      >
        <span/>
      </a>
      <div
        id="menu"
        :class="[
          'header-nav__left-container',
          'scrollactive-nav header-nav',
          { 'opened' : isMenuOpened }
        ]">
        <scrollactive
          :duration="800"
          active-class="active"
          :always-track="true"
        >
          <div
            v-for="(anchor, key) in sectionName"
            :key="key"
            :class="[
              'scrollactive-item__wrapper',
            ]"
            @click="closeNav()"
          >
              <a
                :href="`#${anchor.name}`"
                :title="anchor.name"
                :class="[
                'scrollactive-item',
                anchor.name,
              ]"
              >
                {{ translate(anchor.translate) }}
              </a>
          </div>
        </scrollactive>
      </div>
      <div class="header-nav__logo">
        <div class="header-nav__logo-img-wrapper">
          <img
            src="/assets/images_new/logo.svg"
            alt="logo"
            class="header-nav__logo-img"
          >
        </div>
      </div>
      <div class="header-nav__right-container">
        <a
          class="header-nav__button-play scrollactive-item"
          @click="goToMainSite()"
        >
          <div class="header-nav__button-play-icon-before">
            <SVGIcon
              :name="'sword'"
              :colors="'180deg, rgb(255 255 255 / 0.15), rgb(255 255 255 / 0)'"
            />
          </div>
          <div
            class="header-nav__button-play-text"
          >
            Join Now
          </div>
        </a>
      </div>
    </div>
    <!-- MAIN CONTENT -->
    <main
      class="section__main"
    >
      <!-- VIDEO SECTION -->
      <section
        id="intro-section"
        :class="[
          'section section__video',
        ]"
      >
        <div class="section__video-preview-btn-play">
          <Button
            :ga="'buttonPlay'"
            :type="'without-border orange px-70 fs-30'"
            :height="'70px'"
            :tag="'a'"
          >
            <div class="section__video-btn-play-inner">
              <div
                class="section__video-btn-play-text"
              >
                Play Now
              </div>
            </div>
          </Button>
        </div>
      </section>
      <!-- VIDEO SECTION END -->
      <!-- CAROUSEL SECTION -->
      <section
        id="about-section"
        class="section section__carousel"
      >
        <LandingCarousel
            :go-to-tutorial="goToTutorial"
            :items="slidesAbout"
        />
      </section>
      <!-- CAROUSEL SECTION END -->
      <!-- LOGIN SECTION -->
      <section
        class="section__authorization"
      >
        <HomeBaseUnauthorisedContainer
            :go-to-tutorial="goToTutorial"
        />
      </section>
      <!-- LOGIN SECTION END -->
    </main>
    <!-- MAIN CONTENT END -->
    <!-- FOOTER -->
    <footer
      id="play-now-section"
      class="section section__footer"
    >
      <footer class="footer">
        <scrollactive
          class="footer-nav"
          active-class="active"
          :offset="0"
          :duration="500"
          bezier-easing-value=".5,0,.35,1"
          :highlight-first-item="true"
          :always-track="true"
        >
          <a
            v-for="(anchor, key) in sectionName"
            :key="key"
            :href="`#${anchor.name}`"
            class="footer-scrollactive-item"
          >
            {{ translate(anchor.translate) }}
          </a>
        </scrollactive>

        <div class="footer-links">
          <a
            :href="`${$mainUrl}terms_of_service`"
            class="footer-link"
          >
            {{ $t('footer.ToS') }}
          </a>
          <a
            :href="`${$mainUrl}privacy_policy`"
            class="footer-link"
          >
            {{ $t('footer.pp') }}
          </a>
          <a
            :href="`${$mainUrl}cookie_policy`"
            class="footer-link"
          >
            {{ $t('footer.cp') }}
          </a>
          <a
            href="https://docs.nethernite.com"
            class="footer-link"
          >
            {{ $t('footer.api') }}
          </a>
        </div>
        <div class="footer__logo-wrapper footer__logo-wrapper--big">
          <img
            :src="`${$cdnUrl}/assets/images/header/mobile/logo.png`"
            class="footer__logo"
            alt="logo"
          >
        </div>
        <div class="footer__container footer__container--md">
          <div class="footer__copyright">

          </div>
          <div class="footer__social-items">
            <div class="footer__social">
              <a
                class="footer__social-link footer__social-link--discord"
                :href="$socialLinks.discord"
                target="_blank"
              />
            </div>
            <div class="footer__social">
              <a
                class="footer__social-link footer__social-link--facebook"
                :href="$socialLinks.facebook"
                target="_blank"
              />
            </div>
            <div class="footer__social">
              <a
                class="footer__social-link footer__social-link--twitter"
                :href="$socialLinks.twitter"
                target="_blank"
              />
            </div>
            <div class="footer__social">
              <a
                class="footer__social-link footer__social-link--youtube"
                :href="$socialLinks.youtube"
                target="_blank"
              />
            </div>
            <div class="footer__social">
              <a
                class="footer__social-link footer__social-link--instagram"
                :href="$socialLinks.instagram"
                target="_blank"
              />
            </div>
          </div>
          <div class="footer__copyright">
            {{ $t('footer.copyright') }}
          </div>
        </div>
      </footer>
    </footer>
    <!-- FOOTER END -->
  </section>
</template>

<script lang="js">

import Button from '../baseComponents/ui/Button.vue';
import SVGIcon from '../baseComponents/ui/SVGIcon.vue';
import LandingCarousel from './landing/LandingCarousel.vue';
// import SetCurrentLocale from '../modules/mixins/SetCurrentLocale';
import HomeBaseUnauthorisedContainer from './home/HomeBaseUnauthorisedContainer.vue';
import slides_about from './slides/slides_about.json';
import slides_modes from './slides/slides_modes.json';

export default {
  name: 'Srccomponentslanding',
  components: {
    Button,
    SVGIcon,
    LandingCarousel,
    HomeBaseUnauthorisedContainer,
  },
  props: {},
  data() {
    return {
      showDesktopLangMenu: false,
      showMobileLangMenu: false,
      slidesAbout: slides_about,
      slidesModes: slides_modes,
      sectionName: [
        {
          name: 'intro-section',
          translate: 'nav.intro',
        },
        {
          name: 'about-section',
          translate: 'nav.game_modes',
        },
      ],
      localeCookieName: 'current_language',
      locale: this.$cookies.get(this.localeCookieName),
      isMenuOpened: false,
      prevScrollpos: 0,
      isVisibleVideo: false,
      inMove: false,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      windowWidth: 0,
    };
  },
  computed: {
    languages() {
      const AllLang = this.$lodash.forOwn(this.$i18n.messages);
      return this.$lodash.filter(AllLang, (lang) => lang.i18n.locale !== this.currentLang);
    },
    currentLang() {
      return this.$i18n.locale;
    },
    videoLocal() {
      return this.$i18n.locale === 'en' ?
              'https://www.youtube.com/embed/G6_aPjhwaNU?autoplay=1&modestbranding=1&rel=0' :
              'https://www.youtube.com/embed/1zHi9QxTF1U?autoplay=1&modestbranding=1&rel=0';
    },
  },
  created() {
    window.addEventListener('click', this.close);
    window.addEventListener('scroll', this.hideNavOnScroll);
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close);
  },
  // async beforeMount() {
  //   await this.$store.state.user.loadingPromise;
  //   this.setCurrentLocale(this.$store.state.user.language);
  // },
  beforeMount() {
    this.locale = this.$cookies.get(this.localeCookieName);
      if (this.locale === null) {
      this.locale = 'en';
    }
    this.setCurrentLocale(this.locale);
  },
  mounted() {
    window.addEventListener('resize', this.$lodash.debounce(this.handleResize, 150));
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('scroll', this.hideNavOnScroll);
  },
  methods: {
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.showDesktopLangMenu = false;
      }
    },
    setCurrentLocale(lang){
      this.showDesktopLangMenu = false;
      this.$i18n.locale = lang;
      this.$cookies.set(this.localeCookieName, lang);
    },
    translate(data) {
      return this.$i18n.t(data);
    },
    get_cookie_lang() {
      return this.$cookies.get(this.localeCookieName);
    },
    toggleMenu () {
      this.isMenuOpened = !this.isMenuOpened;
    },
    closeNav() {
      this.isMenuOpened = false;
    },
    hideNavOnScroll() {
      let topPosition = '0px';

      let currentScrollPos = window.pageYOffset;
      // eslint-disable-next-line
      if (this.prevScrollpos > currentScrollPos) {
        document.getElementById("navbar").style.top = topPosition;
      } else {
        document.getElementById("navbar").style.top = "-90px";
        this.closeNav();
      }
      this.prevScrollpos = currentScrollPos;
    },
    executeIfElementExistsInDOM(elementTagName) {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          const element = document.getElementsByTagName(elementTagName);
          if (element !== null) {
            clearInterval(interval);
            resolve(element);
          }
        }, 100);
      });
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    goToTutorial(event) {
      gtag('event', 'click', { 'event_category': 'landing_tutorial',  'event_label': event }); // eslint-disable-line no-undef
      gtag('event', 'click', { 'event_category': 'landing_tutorial',  'event_label': 'play_btn' }); // eslint-disable-line no-undef

      window.location.href = `${process.env.VUE_APP_BASE_API_URL}api/quickstart_auth?source=landing`;
    },
    async goToMainSite() {
      gtag('event', 'click', { 'event_category': 'landing_tutorial',  'event_label': 'play_btn' }); // eslint-disable-line no-undef
      try {
        await fetch(new Request(
          `${this.$mainUrl}api/funnel_01/020/${this.getId()}`,
          {
            method: 'GET',
            mode: 'no-cors',
          })
        );
      } finally {
        window.location.href = `${this.$mainUrl}${this.$utmTags}`;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../static/scss/main";

.fullscreen-bg {
  @include position(fixed, 0, 0, 0, 0);
  overflow: hidden;
  display: block;
  z-index: 1;
  /*@include for-mobile-only {
    display: none;
  }*/
}

.fullscreen-bg_video {
  @include position(absolute, 50%, 50%);
  position: absolute;
  transform: translate(50%, -50%);
  height: auto;
  width: auto;
  min-height: 100%;
  min-width: 100%;
}

.toggle-menu {
  &__mobile {
    display: block;
    width: 28px;
    height: 28px;
    margin-top: 19px;
    margin-left: 28px;
    position: relative;
    z-index: 6;
    @include for-desktop-up {
      display: none;
    }
    span {
      position: relative;
      display: block;
      width: 100%;
      height: 2px;
      background-color: #6f6d99;
      transition: all 0.3s;
      backface-visibility: hidden;
      border-radius: 2px;
      &::before,
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 9px;
        width: 100%;
        height: 2px;
        background-color: #6f6d99;
        transition: all 0.3s;
        backface-visibility: hidden;
        border-radius: 2px;
      }
      &::after {
        top: 18px;
      }
    }
    &.opened {
      span {
        background-color: transparent;
        &::before {
          transform: rotate(45deg) translate(-1px, 0px);
        }
        &::after {
          transform: rotate(-45deg) translate(6px, -7px);
        }
      }
    }
  }
}

.section__main {
  background: {
    color: transparent;
  };
  z-index: 2;
  position: relative;
}

.header-nav__logo {
  position: relative;
}

.header-nav__logo-img-wrapper {
  @include position(absolute, 8px, 0, null, 0);
  width: 100%;
  max-width: 191px;
  margin: 0 auto;
  @include for-desktop-up {
    max-width: 350px;
    top: 10px;
  }
  @include for-big-desktop-up {
    max-width: 390px;
  }
}

.header-nav__right-container {
  @include basic-flex(row, flex-end, center);
}

.header-nav__button-play {
  @include basic-flex(row, center, center);
  min-width: 54px;
  height: 100%;
  background: {
    image: linear-gradient(90deg, #682FBD 0%, #CB4CBC 100%);
  };
  cursor: pointer;
  position: relative;
  text-decoration: none;
  @include for-desktop-up {
    min-width: 214px;
    right: 20%;
  }
  @include for-big-desktop-up {
    min-width: 257px;
  }
  &:hover {
    background: {
      image: linear-gradient(90deg, lighten(#682FBD, 4%) 0%, lighten(#CB4CBC, 4%) 100%);
    };
  }
}

.header-nav__button-play-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  @include for-desktop-up {
    margin-right: 10px;
  }
}

.header-nav__button-play-icon-before {
  @include position(absolute, 50%, null, 0, 0);
  transform: translateY(-50%);
  width: 54px;
  height: 54px;
  @include for-desktop-up {
    left: 30px;
  }
}

.header-nav__button-play-text {
  @include site-font(default, 16px, 500);
  line-height: 23px;
  color: #FFFFFF;
  user-select: none;
  display: none;
  @include for-desktop-up {
    display: inline-block;
  }
  @include for-big-desktop-up {
    font-size: 20px;
  }
}

.section__video {
  @include basic-flex(row, center, center);
  min-height: 97vh;
  padding-bottom: 30px;
  position: relative;
  /*@include for-mobile-only {
    background: {
      image: url('/assets/video/videoplayback.00_00_22_00.Still001.png');
      size: cover;
      position: center;
    };
  }*/
  @include for-desktop-up {
    min-height: 95vh;
    padding-bottom: 70px;
  }
  /*@include for-big-desktop-up {
    min-height: 920px;
    padding-bottom: 50px;
  }*/
}

.section__video-wrapper {
  @include basic-flex(row, center, center);
  width: 350px;
  height: 416px;
  padding: 10px;
  @include for-phone-landscape-up {
    width: 540px;
    height: 408px;
    padding: 4px;
  }
  @include for-desktop-up {
    width: 968px;
    height: 514px;
  }
  @include for-big-desktop-up {
    width: 1180px;
    height: 640px;
    padding: 25px 30px;
  }
}

.section__video-wrapper--open {
  padding: 0;
}

.section__video-preview {
  @include basic-flex(column, center, center);
  width: 100%;
  height: 100%;
}

.section__video-preview-title {
  @include site-font(Leksa, 36px, 600);
  line-height: 36px;
  text-align: center;
  text-shadow: 3px 3px 2px rgb(0 0 0 / 50%);
  color: #FFFFFF;
  @include for-desktop-up {
    font-size: 48px;
    line-height: 54px;
  }
  @include for-big-desktop-up {
    font-size: 80px;
    line-height: 98px;
  }
}

.section__video-preview-description {
  @include site-font(default, 16px, 400);
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
  padding-top: 30px;
  text-shadow: 2px 2px 2px rgb(0 0 0 / 50%);
  @include for-desktop-up {
    font-size: 20px;
    line-height: 32px;
    padding-top: 17px;
  }
  @include for-big-desktop-up {
    font-size: 24px;
    line-height: 38px;
  }
}

.section__video-preview-btn-play {
  @include position(absolute, null, 50%, 30px);
  transform: translateX(50%);
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  @include for-mobile-only {
    max-width: 280px;
    .btn-custom-block {
      height: 70px;
      max-height: 70px !important;
    }
  }
}

.section__video-btn-play-inner {
  @include basic-flex(row, center, center);
}

.section__video-btn-play-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.section__video-btn-play-text {
  @include site-font(Leksa, 30px, 600);
  line-height: 30px;
  color: #FFFFFF;
  text-shadow: none;
  @include for-mobile-only {
    font-size: 30px;
  }
}

.section__watch-video-btn-container {
  margin: 41px auto 0;
}

.section__watch-video-btn {
  @include basic-flex(row, center, center);
  cursor: pointer;
}

.section__watch-video-btn-icon {
  display: inline-block;
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.section__watch-video-btn-text {
  @include site-font(default, 16px, 400);
  line-height: 19px;
  color: #FFFFFF;
}

.section__carousel {
  min-height: 515px;
  background: {
    image: url("/assets/images_new/section__carousel__bg.png");
    size: cover;
    repeat: no-repeat;
    color: #0d0d15;
  };
  @include for-desktop-up {
    min-height: 770px;
  }
  @include for-big-desktop-up {
    min-height: 800px;
  }
}

.section__authorization {
  background: {
    color: #0d0d15;
  }
}

.section__footer {
  position: relative;
  z-index: 4;
  background-color: #141420;
}

.section__video-iframe {
  position: relative;
  width: 100%;
  height: 100%;
  iframe {
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: 1fr;
  }
}

.video-iframe__close-btn {
  @include position(absolute, -10px, -10px);
  @include basic-flex(row, center, center);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(#9c3ebc, 0.5);
  cursor: pointer;
  @include for-phone-landscape-up {
    top: -35px;
    right: -35px;
    background-color: rgba(#000000, 0.3);
  }
}

.video-iframe__close-btn-icon {
  width: 10px;
  height: 10px;
}

.landing {
  &__nav-container {
    @include position(fixed, 0, 0, null, 0);
    grid-template-columns: 1fr 191px 1fr;
    display: grid;
    height: 54px;
    z-index: 12;
    transition: top 0.3s;
    background: {
      color: #131320;
    }
    @include for-desktop-up {
      grid-template-columns: 1fr 400px 1fr;
      top: 0;
      right: 0;
      left: 0;
    }
    @include for-big-desktop-up {
      height: 64px;
    }
  }

  .footer-links {
    .footer-link {
      @include site-font(default, 12px, 500);
      color: #777189;
      margin: 0 5px;
      white-space: pre;
      @include for-tablet-portrait-up {
        font-size: 14px;
        white-space: inherit;
        margin: 0 20px;
      }
      @include for-big-desktop-up {
        font-size: 16px;
      }
      &:hover {
        color: lighten(#777189, 5%);
        text-decoration: none;
      }
    }
  }
  .footer {
    padding: 30px 20px 30px;
    background: {
      color: #141420;
    }
    width: 100%;
    height: 100%;
    @include for-tablet-portrait-up {
      padding: 50px 20px 60px;
    }
    @include for-big-desktop-up {
      padding: 65px 0 70px;
    }
    &__lang-content {
      @include site-font(default, 14px, 400);
      line-height: 16px;
      text-align: right;
      color: #777189;
      position: relative;
      cursor: pointer;
      @include for-big-desktop-up {
        font-size: 16px;
      }
      &.open {
        .languages-list {
          @include basic-flex(column, center, center);
          @include position(absolute, 22px, 50%, null, null);
          transform: translate(50%);
          z-index: 3;
          @include for-tablet-portrait-up {
            @include basic-flex(column, flex-end, flex-end);
            right: 0;
            transform: translate(0%);
          }
          li {
            margin-bottom: 5px;
            &:hover {
              color: lighten(#777189, 10%);
            }
            &.active {
              color: darken(#777189, 10%);
              cursor: default;
            }
          }
        }
        .current-language {
          &::after {
            transform: rotate(180deg);
          }
        }
      }
      .current-language {
        padding-right: 18px;
        position: relative;
        &::after {
          content: '';
          @include position(absolute, 4px, 0, null, null);
          width: 13px;
          height: 8px;
          background: {
            size: contain;
            repeat: no-repeat;
            image: url("/assets/images/landing_3/lang-switcher-icon.svg");
          };
        }
      }
      .languages-list {
        display: none;
        margin-bottom: 0;
        padding: 10px 5px 5px 5px;
        border-radius: 0 0 5px 5px;
        min-width: 120px;
        background: {
          color: #323145;
        }
        @include for-tablet-portrait-up {
          min-width: 110px;
          border-radius: 5px 0 5px 5px;
        }
        @include for-big-desktop-up {
          min-width: 125px;
        }
      }
    }
    &__join-us {
      @include site-font(default, 14px, 400);
      line-height: 16px;
      text-align: center;
      color: #777189;
      margin-top: 20px;
      margin-bottom: 20px;
      @include for-tablet-portrait-up {
        margin-top: 20px;
        margin-bottom: 0;
      }
      @include for-big-desktop-up {
        font-size: 16px;
      }
    }
    &__lang-wrapper {
      @include site-font(default, 18px, 400);
      line-height: 21px;
      color: #777189;
      flex-basis: 33%;
      text-align: right;
      user-select: none;
      margin-top: 30px;
      @include for-tablet-portrait-up {
        margin-top: 0;
      }
    }
    &__social-items {
      @include basic-flex(row, center, center);
      flex-basis: 33%;
    }
    &__social-link {
      display: inline-block;
      width: 24px;
      height: 24px;
      background: {
        size: contain;
        repeat: no-repeat;
      }
      margin: 0 12px;
      @include for-big-desktop-up {
        width: 30px;
        height: 30px;
      }

      &.footer__social-link--youtube {
        height: 17px;
        @include for-big-desktop-up {
          height: 21px;
        }
      }
    }
    &__copyright {
      @include site-font(default, 14px, 400);
      color: #ffffff;
      opacity: 0.2;
      flex-basis: 100%;
      text-align: center;
      margin-bottom: 30px;
      @include for-tablet-portrait-up {
        flex-basis: 33%;
        text-align: right;
        margin-bottom: 0;
      }
      @include for-big-desktop-up {
        font-size: 16px;
      }
    }
    &__container {
      @include basic-flex(column, center, center);
      height: auto;
      @include for-tablet-portrait-up {
        @include basic-flex(row, space-between, center);
        height: 24px;
      }
      &--md {
        max-width: 970px;
        margin: 0 auto;
      }
    }
    &__logo-wrapper {
      position: relative;
      margin: 5px auto 5px;
      @include for-tablet-portrait-up {
        margin: 12px auto 13px;
      }
      &--big {
        max-width: 968px;
      }
      &:before {
        content: "";
        @include position(absolute, 35px, null, null, 50%);
        transform: translateX(-50%);
        display: block;
        background: linear-gradient(90deg,transparent,#b5acd9 51.56%,transparent);
        height: 1px;
        width: 100%;
        opacity: 0.2;
        z-index: 0;
      }
    }
    &__logo {
      position: relative;
      width: 65px;
      height: 65px;
      z-index: 2;
    }
  }
  .scrollactive-nav {
    @include basic-flex(row, center, center);
    height: 60px;
    z-index: 5;
    @include for-mobile-only {
      flex-direction: column;
      height: auto;
    }
    &.header-nav {
      @include basic-flex(column, center, center);
      position: absolute;
      opacity: 0;
      height: 0;
      overflow: hidden;
      @include for-desktop-up {
        position: relative;
        opacity: 1;
        height: 54px;
      }
      @include for-big-desktop-up {
        height: 64px;
      }
      &.opened {
        @include for-mobile-only {
          background: rgba(#131320, 0.9);
          @include position(absolute, 54px, 0, null, 0);
          display: block;
          bottom: auto;
          height: auto;
          z-index: 10;
          padding: 28px 0 8px 0;
          opacity: 1;
        }
      }
    }
    &.footer-nav {
      height: auto;
      position: relative;
      background: transparent;
      .footer-scrollactive-item {
        @include site-font(default, 14px, 500);
        color: #FFFFFF;
        line-height: 16px;
        margin: 0 20px 20px;
        @include for-tablet-portrait-up {
          font-size: 18px;
          line-height: 21px;
          margin: 0 20px 30px;
        }
        @include for-big-desktop-up {
          font-size: 20px;
        }
        &:hover {
          text-decoration: none;
        }
      }
    }
    .scrollactive-item {
      @include site-font(default, 16px, 600);
      color: #777189;
      position: relative;
      margin: 0 auto;
      padding: 0 4px;
      line-height: 20px;
      display: block;
      max-width: 200px;
      height: 54px;
      cursor: pointer;
      @include for-mobile-only {
        height: 30px;
        margin: 0 auto 20px;
      }
      @include for-big-desktop-up {
        font-size: 20px;
        padding: 0 20px;
        height: 64px;
      }
      @include for-tablet-landscape-up {
        line-height: 20px;
        display: inline-flex;
        align-items: center;
        margin: 0 15px;
      }
      &:hover {
        text-decoration: none;
        color: lighten(#777189, 30%);
      }
      &.active {
        color: #ffffff;
        &:after {
          content: '';
          @include position(absolute, null, null, 0, 0);
          background-image: linear-gradient(90deg, #ff7c45, #f52bc0);
          height: 3px;
          width: 100%;
          animation-name: stretch;
          animation-duration: 1s;
          animation-timing-function: ease;
          animation-delay: 0;
          animation-direction: alternate;
          animation-fill-mode: none;
          @include for-tablet-landscape-up {
            bottom: 0;
          }
        }
        @keyframes stretch {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
      }
    }
  }
}
$socialIcon: (
  telegram: (
    'telegram_brands.svg'
  ),
  instagram: (
    'instagram_brands.svg'
  ),
  twitter: (
    'twitter_brands.svg'
  ),
  vkontakte: (
    'vkontakte_brands.svg'
  ),
  facebook: (
    'facebook_brands.svg'
  ),
  discord: (
    'discord_brands.svg'
  ),
  youtube: (
    'youtube_brands.svg'
  ),
);

.footer__social {
  @include basic-flex(row, center, center);
}

@each $iconName, $attrs in $socialIcon {
  $icon: nth($attrs, 1);

  .footer__social-link.footer__social-link--#{$iconName} {
    background: {
      image: url("/assets/images/landing_3/#{$icon}");
    };
  }
}

</style>
